import { Link } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";

const FinalCtaSection = () => {
  const textReveal = useScrollReveal({ threshold: 0.2 });
  const ctaReveal = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="py-24 sm:py-36 px-6 bg-[#3F2A24]">
      <div className="max-w-2xl mx-auto text-center space-y-12">

        <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
          L'appel
        </p>

        {/* Texte final */}
        <div
          ref={textReveal.ref}
          className={`space-y-4 font-serif text-base sm:text-lg text-[#F3E5CF]/70 leading-[2.4] scroll-reveal-slow ${textReveal.isVisible ? "visible" : ""}`}
        >
          <p>Si quelque chose en toi</p>
          <p>a reconnu ce passage,</p>
          <div className="h-4" />
          <p className="text-[#F3E5CF]/90">alors quelque chose a déjà commencé.</p>
          <div className="h-4" />
          <p className="italic text-[#C5A059]/80 text-lg sm:text-xl">COCON t'attendait déjà.</p>
        </div>

        <div className="w-10 h-[1px] bg-[#C5A059]/30 mx-auto" />

        {/* Boutons */}
        <div
          ref={ctaReveal.ref}
          className={`flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-8 scroll-reveal ${ctaReveal.isVisible ? "visible" : ""}`}
        >
          <Link
            to="/valouse"
            className="w-full sm:w-auto sm:min-w-[280px] px-14 py-6 rounded-3xl bg-[#C5A059] text-center transition-all duration-500 hover:bg-[#F3E5CF] group formula-card-premium"
            data-testid="final-cta-valouse"
          >
            <span className="block text-sm tracking-[0.12em] uppercase text-[#3F2A24] font-medium">COCON VALOUSE</span>
            <span className="block text-sm text-[#3F2A24]/60 mt-1.5 whitespace-nowrap">Drôme Provençale · Sept. 2026</span>
            <span className="block text-xs text-[#3F2A24]/40 italic font-serif mt-1">Un retour au corps, au lien et à l'essentiel.</span>
          </Link>

          <Link
            to="/cocon-sacre-2026"
            className="w-full sm:w-auto sm:min-w-[280px] px-14 py-6 rounded-3xl bg-[#77574C] text-center transition-all duration-500 hover:bg-[#C5A059] group formula-card-premium"
            data-testid="final-cta-sacre"
          >
            <span className="block text-sm tracking-[0.12em] uppercase text-[#F3E5CF] font-medium group-hover:text-[#3F2A24] transition-colors">COCON SACRÉ</span>
            <span className="block text-sm text-[#F3E5CF]/60 mt-1.5 group-hover:text-[#3F2A24]/60 transition-colors whitespace-nowrap">Bali & Java · Mai – Juin 2026</span>
            <span className="block text-xs text-[#F3E5CF]/40 italic font-serif mt-1 group-hover:text-[#3F2A24]/40 transition-colors">Une immersion entre terre, feu<br/>et transformation intérieure.</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

/* ═══ CONSERVATION TEMPORAIRE — ancien FinalCtaSection ═══
 *
 * Texte:
 *   "Si quelque chose en toi a reconnu ce passage,"
 *   "alors ce cercle t'attendait déjà."
 * Boutons identiques mais avec py-5 px-10
 *
 * ═══ FIN CONSERVATION TEMPORAIRE ═══ */

export default FinalCtaSection;
